export const getProgressColor = (value: number): 'error' | 'success' | 'warning' => {
  if (value < 0.3) {
    return 'error';
  } else if (value < 0.7) {
    return 'warning';
  }
  return 'success';
};
